import { msg } from '@lingui/macro'

import * as React from 'react'

import { useTrans } from '~logic/i18n/useTrans'
import { CartItemTotal } from '~ui/components/cart/CartItemTotal'
import { Grid } from '~ui/components/layout/Box'
import { Skeleton } from '~ui/components/loadingSkeletons/Skeleton'

import { useCartContentCtx } from '../contexts/CartContentProvider'
import { getCartSum } from '../helpers/getCartSum'

type TProps = NoChildren &
  SkeletonProps & {
    creditPayment?: React.ReactNode
  }

/**
 * Separated CartTotalItem from CartContent so it can be placed alone.
 */
export const CartTotal: React.FC<TProps> = ({ showSkeleton, creditPayment }) => {
  const { trans } = useTrans()
  const totalLabel = trans(msg`Total`)

  const order = useCartContentCtx()

  // cart is loading -> show some placeholder skeleton
  if (order === null || showSkeleton) {
    return (
      <Skeleton>
        <CartItemTotal sumLabel={totalLabel} cartSum={``} />
      </Skeleton>
    )
  }

  return (
    <Grid rowGap={`small`}>
      <CartItemTotal sumLabel={totalLabel} cartSum={getCartSum(order)} />
      {creditPayment}
    </Grid>
  )
}
